import React from 'react'
import ReactDOM from 'react-dom'
// Templates
import Note from './templates/Note'

export default function HowToAppNote() {
  const mainText = `
    アプリの使い方を動画で確認しましょう。<br />
    「キクタンアプリの使い方」動画は、以下の「単語の覚え方」プリントをあわせてご確認ください。
  `
  const textList = [
    {
      text: '●「単語の覚え方」プリント （キクタンアプリの使い方 動画用）',
      fileName: '単語の覚え方プリント_STRAIL'
    },
  ]

  return (
    <Note
      mainText={mainText}
      textList={textList}
    />
  )
}

if (document.getElementById('how_to_app')) {
  ReactDOM.render(
    <HowToAppNote />,
    document.getElementById('how_to_app')
  )
}